<template>
    <div>
        <g-divider v-if="!hideDivider" />
        <g-level>
            <g-level-item>
                <g-typography :value="itemCountString" />
                <g-button
                    class="pdf-ignore"
                    minimalist
                    icon="angle-right"
                    :route="route"
                    @click="$emit('click', $event)"
                />
            </g-level-item>
            <g-level-item slot="right">
                <g-button v-if="false" minimalist icon="truck">Track Order</g-button>
            </g-level-item>
        </g-level>
        <g-level>
            <order-status-info :brief="brief" :order="order" />
        </g-level>
        <product-image-list v-if="products" :products="products" />
    </div>
</template>

<script>
    import { pluralize } from '../../../../../helpers/string-helpers';
    import { ACTIVATION_ORDER_SHIPMENT_STATUS_LABELS } from '../../../../../constants/activation-brief-shipment-status';
    import ProductImageList from './ProductImageList.vue';
    import moment from 'moment-timezone';
    import OrderStatusInfo from './OrderStatusInfo.vue';
    import ActivationBriefProductsMixin from '../../../../providers/mixins/ActivationBriefProductsMixin';

    export default {
        name: 'ProductPreview',
        components: {
            ProductImageList,
            OrderStatusInfo
        },
        props: {
            brief: {
                type: Object,
                required: true
            },
            order: {
                type: Object,
                default: () => {}
            },
            hideDivider: {
                type: Boolean,
                default: false
            },
            route: {
                type: String | Object,
                default: null
            }
        },
        mixins: [ActivationBriefProductsMixin],
        data() {
            return {
                products: []
            };
        },
        created() {
            this.getProducts(this.order.items.map((item) => item.product_id)).then((res) => {
                this.products = res;
            });
        },
        computed: {
            itemCountString() {
                const count = this.order.items.length;
                return `${count} ${pluralize(count, 'Item')}`;
            },
            addedDateString() {
                return `Added ${moment(this.order.created_at).format('MMM D, YYYY')} • ${
                    ACTIVATION_ORDER_SHIPMENT_STATUS_LABELS[this.order.shipment_status]
                }`;
            }
        }
    };
</script>
